import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import MessageContainer from "./MessageContainer";
import RatingStar from "../Rating";
import Button from "../Button";
import ChatSessionContext from "../../../contexts/ChatSessionContext";
import useChat from "../../../hooks/useChat";

const RateSupport = (props) => {
  const [score, setScore] = useState(undefined);
  const { currentSession, setIsMinimizeHidden } =
    useContext(ChatSessionContext);
  const { rateSession } = useChat();

  useEffect(() => {
    setIsMinimizeHidden(true);

    return () => {
      setIsMinimizeHidden(false);
    };
  }, []);

  const handleRate = async (rating) => {
    await rateSession(currentSession._id, rating, "");
    setScore(rating);
  };

  return (
    <MessageContainer alignment={"center"}>
      <div
        className="chat-rate-support"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          alignSelf: "center",
        }}
      >
        <span style={{ fontSize: 14, color: "#888" }}>Session has ended</span>
        <span style={{ fontSize: 14, color: "#888", marginBottom: 4 }}>
          {score ? "Thank you" : "Please rate our support"}
        </span>
        <div style={{ marginBottom: 16 }}>
          <RatingStar
            size={24}
            score={score}
            onChange={handleRate}
            readOnly={!!score}
          />
        </div>
        <Button label={"Close"} disabled={!score} onClick={props.onClose} />
      </div>
    </MessageContainer>
  );
};

RateSupport.propTypes = {};

export default RateSupport;
